import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ExchangeRateResponseDto } from '@domain/exchange-rate/dtos/exchange-rate.response.dto';
import { ListExchangeRateRequestDto } from '@domain/exchange-rate/dtos/list-exchange-rate.request.dto';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('exchange-rate');
  }

  list(request: ListExchangeRateRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ExchangeRateResponseDto>>
    >(queryUrl, { params: { ...request } });
  }
}
